import { CircularProgress } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'

const PageLoader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f2f4f6a8',
        height: '100%',
        width: '100%',
        zIndex: 1000,
        position: 'absolute'
      }}
    >
      <CircularProgress />
    </Box>
  )
}

export default PageLoader
